import "../Style/TogglePassengerCount.css"
import { ReactComponent as PeoplesSvg } from "../SVG/peoples.svg"
import { ReactComponent as PercentageSvg } from "../SVG/percentage.svg"
import { useState, useContext } from "react";
import TrainloadContext from "../Store/trainload-context";

const TogglePassengerCount = (props) => {

    const trainloadCtx = useContext(TrainloadContext);
    const [isToggle, setIsToggle] = useState(true);

    const handleToggle = () => {
        // console.log("Toggled PassengerCount", isToggle);
        setIsToggle(prevToggle => !prevToggle);
        trainloadCtx.updateIsPassengerCount(!isToggle);
        // console.log("isPassengerCount", trainloadCtx.isPassengerCount);
    }

    return (
        <div>
            <label className="passenger-count-switch">
                <input type="checkbox" onChange={handleToggle} defaultChecked={props.defaultChecked} />
                <div className="passenger-count-slider">
                    <div className="in-slider">
                        {isToggle ? "Show Passenger Count" : "Show Crowdedness Index"}
                    </div>
                    <PeoplesSvg></PeoplesSvg>
                    <PercentageSvg></PercentageSvg>
                </div>
            </label>
        </div>
    );
}

export default TogglePassengerCount;